import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClassFilterTrigger } from "@components/Class/ClassFilter/ClassFilterTrigger";
import { MatchableItem } from "../types";

export const ClassCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => {
        const { classIds } = row.original;

        if (classIds.length === 0) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                <ClassFilterTrigger value={classIds} />
            </ViewTableCell>
        );
    },
);
ClassCell.displayName = "ClassCell";
